module.exports = __webpack_public_path__ + "189d3c5cc17fdf68e062e512325c6376.fbx";